import _request from '@/utils/request.js'

var _invoiceCompany = {
  // 开票公司列表		
  getContractCompanyList (query, resolve, reject) {
    _request.api({
      url: _request.getCrmUrl("/api/company/getContractCompanyList"),
      params: query,
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  // 开票公司列表		
  getContractCompanyListForSelect (query, resolve, reject) {
    _request.api({
      url: _request.getCrmUrl("/api/company/getContractCompanyListForSelect"),
      params: query,
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  // 修改开票公司状态				
  updateContractCompanyState (id, state, resolve, reject) {
    _request.api({
      url: _request.getCrmUrl("/api/company/updateContractCompanyState"),
      params: {
        id: id,
        state: state
      },
      method: 'post',
      success: resolve,
      error: reject
    })
  },
  // 新增修改开票公司						
  addOrUpdateContractCompany (info, resolve, reject) {
    _request.api({
      url: _request.getCrmUrl("/api/company/addOrUpdateContractCompany"),
      data: info,
      method: 'post',
      success: resolve,
      error: reject
    })
  },
  // 查询开票公司详情
  getContractCompanyDetailFuxi (id, resolve, reject) {
    _request.api({
      url: _request.getCrmUrl("/api/company/getContractCompanyDetail"),
      params: {
        id: id
      },
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  //查询开票公司详情	juyou
  getContractCompanyDetail (id, resolve, reject) {
    _request.api({
      url: _request.getCrmUrl("/api/company/getContractCompanyInfo"),
      params: {
        id: id
      },
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  // 查询开票公司列表		
  getContractCompanyListForSelect (resolve, reject) {
    _request.api({
      url: _request.getCrmUrl("/api/company/getContractCompanyListForSelect"),
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  // 选择主体类型
  getBodyTypeList (query, resolve, reject) {
    _request.api({
      url: _request.getCrmUrl("/api/company/getEnum"),
      params: query,
      method: 'get',
      success: resolve,
      error: reject
    })
  },
}

export default _invoiceCompany